// extracted by mini-css-extract-plugin
module.exports = {"gridCollectionWrapper":"main_gridCollectionWrapper__eUgBD","blockTitle":"main_blockTitle__qC90w","headingBlock":"main_headingBlock__N_OuV"};